import { clsx } from 'clsx';
import { INCREASE_UTP } from './constants';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';

export const IncreaseUtp: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {INCREASE_UTP.map(({ text, imageClass }, index) => (
        <div key={index} className={styles['item']}>
          <div className={styles['textblock']}>{text}</div>
          <div className={clsx(styles['image'], styles[imageClass])} />
        </div>
      ))}
    </div>
  );
};
